import { render, staticRenderFns } from "./MultiDocumentKindListSelector.vue?vue&type=template&id=7670fd5b&scoped=true&"
import script from "./MultiDocumentKindListSelector.vue?vue&type=script&lang=ts&"
export * from "./MultiDocumentKindListSelector.vue?vue&type=script&lang=ts&"
import style0 from "./MultiDocumentKindListSelector.vue?vue&type=style&index=0&id=7670fd5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7670fd5b",
  null
  
)

export default component.exports